import { optionalContextFactory } from '../../../hooks/optional-context-factory';

export type ModalAppConfigState = {
  topOffset: number;
};

const [context, useModalAppConfigContextMethod] = optionalContextFactory<ModalAppConfigState>(
  {} as ModalAppConfigState
);

export type ModalAppConfigProviderProps = React.PropsWithChildren<ModalAppConfigState>;

export const ModalAppConfigProvider = ({ children, ...props }: ModalAppConfigProviderProps) => {
  return <context.Provider value={props}>{children}</context.Provider>;
};

export { useModalAppConfigContextMethod as useModalAppConfigContext };
